/** Finance / platform / delivery sources / events feature reducers */
export async function loadFinanceReducers() {
  const [
    payments,
    paymentBills,
    currencies,
    stripeAccount,
    branchesFinance,
    platform,
    deliverySources,
    affiliateUrl,
    event,
  ] = await Promise.all([
    import('../reducers/PaymentsReducer'),
    import('../reducers/PaymentBillsReducer'),
    import('../reducers/CurrenciesReducer'),
    import('../reducers/StripeReducer'),
    import('../reducers/BranchesFinanceReducers'),
    import('../reducers/PlatformReducers'),
    import('../reducers/DeliverySourcesReducer'),
    import('../reducers/AffiliateUrlLinkReducer'),
    import('../reducers/EventsReducer'),
  ]);

  return {
    payments: payments.default,
    paymentBills: paymentBills.default,
    currencies: currencies.default,
    stripeAccount: stripeAccount.default,
    branchesFinance: branchesFinance.default,
    platform: platform.default,
    deliverySources: deliverySources.default,
    affiliateUrl: affiliateUrl.default,
    event: event.default,
  };
}
